import fp from 'lodash/fp';
import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator, endpointQuery } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const action = createActions({
  CONTENT: {
    LOAD_MORE: (skip, query) => ({ skip, query }),
    API: {
      LOAD_MORE: apiResourceActionCreator('contentResult')
    }
  }
})

export const apiAction = (authToken, skip, query) => commonApiActions.authenticated.get(`${API_ENDPOINT}${endpointQuery({ ...(query || {}), skip })}`, authToken, action.content.api.loadMore)

export function* loadMoreContent(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, action.payload.skip, action.payload.query));
}

const configuration = {
  name: 'loadMore',
  action: action,
  sagas: loadMoreContent,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetching: true,
      isLoadingMore: true
    }),
    success: (state, action) => {
      const nextcontent = fp.concat(state.contentResult.content, action.payload.contentResult.content);
      const nextContentResult = Object.assign({}, action.payload.contentResult, { content: nextcontent });
      return {
        ...state,
        isFetching: false,
        isLoadingMore: false,
        contentResult: nextContentResult,
        error: null
      }
    },
    failed: (state, action) => ({
      ...state,
      isFetching: false,
      isLoadingMore: false,
      error: action.payload.error
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/content/configurations/loadMore.js